import { providerType } from '@repo/shared/types';
export function areP24MarketingDataAccepted(marketingData) {
    if (!marketingData || marketingData.length === 0)
        return false;
    var p24ProviderMarketingAgreements = marketingData.filter(function (agreement) { return agreement.provider === providerType.enum.przelewy24; });
    if (p24ProviderMarketingAgreements.length === 0)
        return false;
    return p24ProviderMarketingAgreements.every(function (agreement) { return agreement.accepted; });
}
